import { gql } from "@apollo/client";

const SAVE_ARCHIVO_VISITA = gql`
    mutation saveArchivoVisita($input: VisitaArchivoModelInput!){
        saveArchivoVisita(input: $input) {
            success
            error
            valorEsperado
        }
    }
`;

export default SAVE_ARCHIVO_VISITA;

export const adaptVisitaArchivoModelInput = (data) => ({
  idArchivo: data.idArchivo,
  idTipoArchivoDocumento: data.idTipoArchivoDocumento,
  idVisita: data.idVisita,
  titulo: data.titulo,
  extension: data.extension,
  archivo: data.archivo,
  contentType: data.contentType,
  fechaAlta: data.fechaAlta
});